import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import EventService from '../../Services/eventListService';

// Thunks for async actions
export const fetchEvents = createAsyncThunk('events/fetchAll', async (_, { rejectWithValue }) => {
  try {
    const response = await EventService.getAll();
    console.log("eventlist reducer", response);
    return response;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const createEvent = createAsyncThunk('events/create', async (eventData, { rejectWithValue }) => {
  try {
    const response = await EventService.create(eventData);
    return response;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const updateEvent = createAsyncThunk('events/update', async ({ eventId, eventData }, { rejectWithValue }) => {
  try {
    const response = await EventService.update(eventId, eventData);
    return response;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const deleteEvent = createAsyncThunk('admin/deleteEvent', async (eventId, { rejectWithValue }) => {
  try {
    
    await EventService.delete(eventId);
    return eventId;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

// Slice
const eventSlice = createSlice({
  name: 'events',
  initialState: {
    events: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEvents.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchEvents.fulfilled, (state, action) => {
        state.loading = false;
        state.events = action.payload;
      })
      .addCase(fetchEvents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createEvent.fulfilled, (state, action) => {
        state.events.push(action.payload);
      })
      .addCase(updateEvent.fulfilled, (state, action) => {
        const index = state.events.findIndex(event => event.id === action.payload.id);
        if (index !== -1) {
          state.events[index] = action.payload;
        }
      })
      .addCase(deleteEvent.fulfilled, (state, action) => {
        console.log("Deleted event ID in reducasaser:", state);
        // state.events = state.events.filter(event => event.id !== action.payload);
      });
  }
});

export default eventSlice.reducer;
